module.exports = __webpack_public_path__ + "img/img13.7146f705.png";